<template>
    <div>
        <div class="row text-h6"><p>My Account Details</p></div>
        <div class="row">
            <q-card class="bg-white q-pa-md col-md-6 col-xs-12">
                <div v-if="getAccountInfoData" class="row items-center no-wrap q-mb-xs">
                    <div class="col">
                        <q-badge v-for="role in getAccountInfoData.roles" :key="role.id" align="top" transparent color="primary" class="q-mr-xs">{{ role.name }}</q-badge>
                        <q-badge align="top" transparent :color="getAccountStatusColor(getAccountInfoData.status)" class="q-mr-xs ">{{ getAccountStatus(getAccountInfoData.status) }}</q-badge>
                        <q-badge v-if="getAccountInfoData.lockoutEndDateUtc" align="top" transparent color="negative" class="q-mr-xs">Locked</q-badge>
                        <q-badge v-if="getAccountInfoData.isTestAccount" outline align="top" transparent color="warning" class="q-mr-xs">Test Account</q-badge>
                    </div>
                </div>
                <div v-else>
                    <div class="col">
                        <q-badge align="top" transparent color="primary" class="q-mr-xs" />
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <q-form class="q-col-gutter-sm" autocomplete="off">

                            <div class="row">
                                <div class="col-6 q-pr-sm">
                                    <q-input :outlined="isEditMode" dense :readonly="!isEditMode"
                                             label="First Name" stack-label
                                             autocomplete="on" name="firstName"
                                             v-model.trim="form.firstName"
                                             :rules="[ val => $v.form.firstName.required || 'First name is required' ]"
                                             hide-bottom-space />
                                </div>
                                <div class="col-6">
                                    <q-input :outlined="isEditMode" dense :readonly="!isEditMode"
                                             label="Last Name" stack-label
                                             autocomplete="on" name="lastName"
                                             v-model.trim="form.lastName"
                                             :rules="[ val => $v.form.lastName.required || 'Last name is required' ]"
                                             hide-bottom-space />
                                </div>
                            </div>

                            <q-input :outlined="isEditMode" dense readonly
                                     label="E-mail" stack-label
                                     autocomplete="on" name="email"
                                     type="email"
                                     v-model.trim="form.email"
                                     hide-bottom-space />

                            <q-input :outlined="isEditMode" dense :readonly="!isEditMode"
                                     label="Website" stack-label
                                     autocomplete="on" name="website"
                                     v-model.trim="form.website"
                                     hide-bottom-space />

                            <q-input :outlined="isEditMode" dense :readonly="!isEditMode"
                                     label="Company" stack-label
                                     autocomplete="on" name="company"
                                     v-model.trim="form.company"
                                     hide-bottom-space />

                            <div class="row">
                                <div class="col-7 q-pr-sm">
                                    <q-input :outlined="isEditMode" dense :readonly="!isEditMode"
                                             label="Phone" stack-label
                                             autocomplete="on" name="phone"
                                             v-model.trim="form.phone"
                                             :rules="[ val => $v.form.phone.required || 'Phone number is required' ]"
                                             hide-bottom-space />
                                </div>
                                <div class="col-5">
                                    <q-input :outlined="isEditMode" dense :readonly="!isEditMode"
                                             label="Ext." stack-label
                                             autocomplete="on" name="extension"
                                             v-model.trim="form.extension"
                                             type="tel"
                                             hide-bottom-space />
                                </div>
                            </div>
                            <q-input :outlined="isEditMode" dense :readonly="!isEditMode"
                                     label="Address" stack-label
                                     autocomplete="on" name="address"
                                     v-model.trim="form.address"
                                     :rules="[ val => $v.form.address.required || 'Street address is required' ]"
                                     hide-bottom-space />
                            <div class="row">
                                <div class="col-7 q-pr-sm">
                                    <q-input type="hidden" name="Country_hidden_input" label="Country Hidden Input" style="display: none;" />
                                    <q-select :outlined="isEditMode" dense :readonly="!isEditMode" stack-label
                                              autocomplete="off" name="drop_down_input"
                                              @input="setProvStates()"
                                              v-model.trim="form.country" :options="countries"
                                              option-value="key"
                                              option-label="value"
                                              @filter="countryFilterFn"
                                              use-input
                                              fill-input
                                              hide-selected
                                              input-debounce="0"
                                              :loading="getCountriesPending"
                                              :rules="[ val => $v.form.country.required || 'Country is required' ]"
                                              hide-bottom-space>
                                        <template v-slot:prepend>
                                            <span v-html="'<span>C&#8204;ountry</span>'" style="position: absolute; transform: translateY(-30%) scale(0.75); font-size: 14px; top: 7px; left: 5px;" />
                                        </template>
                                    </q-select>
                                </div>
                                <div class="col-5">
                                    <q-input :outlined="isEditMode" dense :readonly="!isEditMode"
                                             label="Postal" stack-label
                                             autocomplete="on" name="postal"
                                             v-model.trim="form.postal"
                                             :rules="[ val => $v.form.postal.required || 'Postal is required' ]"
                                             hide-bottom-space />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-7 q-pr-sm">
                                    <q-input :outlined="isEditMode" dense :readonly="!isEditMode"
                                             label="City" stack-label
                                             autocomplete="on" name="city"
                                             v-model.trim="form.city"
                                             :rules="[ val => $v.form.city.required || 'City is required' ]"
                                             hide-bottom-space />
                                </div>
                                <div class="col-5">
                                    <q-input type="hidden" name="ProvState_hidden_input" label="Prov/State Hidden Input" style="display: none;" />
                                    <q-select v-if="!isCountryOther" stack-label
                                              autocomplete="off" name="drop_down_input"
                                              :outlined="isEditMode" dense :readonly="!isEditMode"
                                              :disable="!form.country"
                                              v-model.trim="form.provState" :options="provStates"
                                              option-value="key"
                                              option-label="value"
                                              @filter="provStateFilterFn"
                                              use-input
                                              fill-input
                                              hide-selected
                                              input-debounce="0"
                                              :loading="getProvincesPending || getStatesPending"
                                              :rules="[ val => $v.form.provState.required || 'State/Prov is required' ]"
                                              hide-bottom-space>
                                        <template v-slot:prepend>
                                            <span v-html="'<span>S&#8204;tate/P&#8204;rov</span>'" style="position: absolute; transform: translateY(-30%) scale(0.75); font-size: 14px; top: 7px; left: 5px;" />
                                        </template>
                                    </q-select>
                                    <q-input v-else
                                             :outlined="isEditMode" dense :readonly="!isEditMode"
                                             label="State/Prov" stack-label
                                             autocomplete="on" name="provState"
                                             v-model.trim="form.provState"
                                             :rules="[ val => $v.form.provState.required || 'State/Prov is required' ]"
                                             hide-bottom-space />
                                </div>
                            </div>
                            <div class="q-mt-md">
                                <div v-if="isEditMode" class="row q-col-gutter-sm">
                                    <div class="col-xs-12 col-sm-auto">
                                        <q-btn :label="updateAccountInfoPending ? 'Saving...' : 'Save'"
                                               @click="onSubmit" color="primary" class="full-width" />
                                    </div>
                                    <div class="col-xs-12 col-sm-auto">
                                        <q-btn label="Cancel" @click="onReset" color="primary" flat class="full-width" v-close-popup />
                                    </div>
                                </div>
                                <div v-else class="row q-col-gutter-sm">
                                    <div class="col-xs-12 col-sm-auto">
                                        <q-btn label="Edit" @click="isEditMode = true" color="primary" class="full-width" />
                                    </div>
                                    <div class="col-xs-12 col-sm-auto">
                                        <q-btn label="Change Password" class="full-width" color="warning" @click="showResetPass = true" />
                                    </div>
                                </div>
                            </div>
                        </q-form>
                    </div>
                </div>

                <dialog-change-password v-if="getAccountInfoData"
                                        :id="getAccountInfoData.id"
                                        :show.sync="showResetPass" />

                <q-inner-loading :showing="getAccountInfoPending || updateAccountInfoPending">
                    <div>
                        <q-spinner color="primary"
                                   :thickness="2"
                                   size="3em" />
                    </div>
                </q-inner-loading>
            </q-card>
        </div>
    </div>
</template>
<script>
    import dialogChangePassword from '@/components/dialogs/DialogChangePassword'
    import { required } from 'vuelidate/lib/validators'
    import { mapState } from 'vuex'
    export default {
        name: 'account-info',
        components: {
            dialogChangePassword,
        },
        data() {
            return {
                showResetPass: false,
                isEditMode: false,
                isCountryOther: false,
                form: {
                    email: '',
                    firstName: '',
                    lastName: '',
                    company: '',
                    address: '',
                    city: '',
                    provState: '',
                    country: '',
                    postal: '',
                    phone: '',
                    extension: '',
                    website: '',
                },
                countries: [],
                provStates: [],
            }
        },
        validations: {
            form: {
                firstName: { required },
                lastName: { required },
                address: { required },
                city: { required },
                provState: { required },
                country: { required },
                postal: { required },
                phone: { required },
            }
        },
        methods: {
            onSubmit() {
                this.$v.form.$touch()
                if (this.$v.form.$pending || this.$v.form.$error || this.$v.form.$invalid) return
                this.updateAccount()
            },

            onReset() {
                this.isCountryOther = false
                this.isEditMode = false
                this.syncForm()
            },
            updateAccount() {
                this.$store.dispatch('updateAccountInfo', this.setupAccountModel()).then(() => {
                    this.isEditMode = false
                    this.getAccountInfo()
                    this.$q.notify({
                        type: 'positive',
                        message: 'Account has been updated'
                    })
                    if (this.form.country)
                        this.$store.dispatch('updateCurrency', this.form.country?.key)
                })
            },
            getAccountInfo() {
                this.$store.dispatch('getAccountInfoByEmail', this.user.username).then(() => {
                    this.syncForm()
                })
            },
            syncForm() {
                if (this.getAccountInfoData) {
                    this.form.email = this.getAccountInfoData.email
                    this.form.firstName = this.getAccountInfoData.firstName
                    this.form.lastName = this.getAccountInfoData.lastName
                    this.form.company = this.getAccountInfoData.company
                    this.form.address = this.getAccountInfoData.address
                    this.form.city = this.getAccountInfoData.city

                    let l = this.getCountriesData?.find(l => l.key == this.getAccountInfoData.country) ?? null
                    this.form.country = l ?? this.countries?.find(l => l.value == 'Other')
                    this.setProvStates()
                    let p = this.provStates?.find(p => p.key == this.getAccountInfoData.provState || p.value == this.getAccountInfoData.provState) ?? null
                    this.form.provState = p ?? this.getAccountInfoData.provState

                    this.form.postal = this.getAccountInfoData.postal
                    this.form.phone = this.getAccountInfoData.phone
                    this.form.extension = this.getAccountInfoData.extension
                    this.form.website = this.getAccountInfoData.website
                }
            },
            countryFilterFn(val, update, abort) {
                update(() => {
                    if (val === '') {
                        this.countries = this.getCountriesData
                    }
                    else {
                        const needle = val.toLowerCase()
                        this.countries = this.getCountriesData?.filter(c => c.value.toString().toLowerCase().indexOf(needle) > -1)
                    }
                })
            },
            provStateFilterFn(val, update, abort) {
                update(() => {
                    if (val === '') {
                        if (this.form.country) {
                            if (this.form.country?.key == 0)
                                this.provStates = this.getStatesData
                            else if (this.form.country?.key == 1)
                                this.provStates = this.getProvincesData
                        }
                    }
                    else {
                        const provStateOptions = this.provStates
                        const needle = val.toLowerCase()
                        this.provStates = provStateOptions?.filter(c => c.value.toString().toLowerCase().indexOf(needle) > -1)
                    }
                })
            },
            setProvStates() {
                if (this.form.country) {
                    this.form.provState = ''
                    if (this.form.country?.key == 0) {
                        this.isCountryOther = false
                        this.provStates = this.getStatesData
                    }
                    else if (this.form.country?.key == 1) {
                        this.isCountryOther = false
                        this.provStates = this.getProvincesData
                    }
                    else this.isCountryOther = true
                }

            },
            setupAccountModel() {
                const accountModel = {
                    id: this.getAccountInfoData.id,
                    firstName: this.form.firstName,
                    lastName: this.form.lastName,
                    company: this.form.company,
                    address: this.form.address,
                    city: this.form.city,
                    provState: this.form.provState.value ?? this.form.provState,
                    country: this.form.country?.key,
                    postal: this.form.postal,
                    phone: this.form.phone,
                    extension: this.form.extension,
                    website: this.form.website,
                }
                return accountModel
            },

        },
        computed: {
            ...mapState([
                'updateAccountInfoPending',
                'updateAccountInfoData',

                'getAccountInfoPending',
                'getAccountInfoData',

                'getCountriesPending',
                'getCountriesData',

                'getProvincesPending',
                'getProvincesData',

                'getStatesPending',
                'getStatesData',

            ]),
            user() { return this.$store.getters.authUser },
        },
        created() {
            this.getAccountInfo()
        },
        watch: {
            getAccountInfoData(newVal, oldVal) {
                if (newVal && newVal !== oldVal) {
                    this.syncForm()
                }
            },
        }
    }
</script>
<style>
    .q-field__native {
        padding-top: 14px;
        padding-bottom: 2px;
    }

    .q-field__prepend {
        padding: 0 !important;
    }
</style>
